const RetiredChip = ({ deactivatedDate }: { deactivatedDate: string }) => {
  return (
    <div
      className={`px-2 py-1 bg-red-100 rounded-full border border-red-700 inline-flex justify-center items-center gap-1`}
    >
      <p className={`text-red-700 text-xs font-medium`}>
        Retired {deactivatedDate}
      </p>
    </div>
  );
};

export default RetiredChip;
